import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import {Subject} from "rxjs";
import UploadTask = firebase.storage.UploadTask;

@Injectable()
export class ImageProvider {

    constructor() {
    }

    profilePics = new Map<string, Subject<string>>();

    public generateUUID(): string {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }

        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }

    /**
     * Store a profile image for a user
     * @param file the picture file
     * @param userId the user id
     */
    uploadProfileImage(file: any, userId: string): UploadTask {
        let storageRef = firebase.storage().ref(`/images/${userId}/profile.jpg`);
        return storageRef.put(file);
    }

    /**
     * Remove users profile image
     * @param userId the user id
     */
    removeProfileImage(userId: string): firebase.Promise<any> {
        let storageRef = firebase.storage().ref(`/images/${userId}/profile.jpg`);
        return storageRef.delete()
    }

    uploadImage(image: string, userId: string): any {
        let storageRef = firebase.storage().ref();
        let imageName = this.generateUUID();
        let imageRef = storageRef.child(`${userId}/${imageName}.jpg`);
        imageRef.putString(image, 'data_url');
        return imageName;
    }

    getProfileImageURL(uid: string,
                       success = null,
                       failure = null): any {
        let storageRef = firebase.storage().ref();

        storageRef.child(`/images/${uid}/profile.jpg`).getDownloadURL().then(
            function (url) {
                //console.log("Got download url: " + url);
                if (success) success(url);
            },
            function (error) {
                //console.log("Error getting download url: " + error.message);
                if (failure) failure();
            }
        );
    }

    getImage(userId: string, imageId: string): any {
        let storageRef = firebase.storage().ref();
        let imageRef = storageRef.child(`${userId}/${imageId}.jpg`);
        let bla = imageRef.getDownloadURL().then(data => {
            //console.log(data.toString());
        });
        return bla.toString();
    }

}



// WEBPACK FOOTER //
// ./src/providers/image/imageProvider.ts